// import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useState, useEffect, useRef } from 'react';
import ImageUploading from 'react-images-uploading';
// import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
// import { useSnackbar } from 'notistack5';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
import closeFill from '@iconify/icons-eva/close-fill';
// material
import { LoadingButton } from '@material-ui/lab';
import {
  Box,
  Grid,
  Stack,
  Switch,
  Typography,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  Divider,
  Button,
  Radio,
  RadioGroup,
  Paper
} from '@material-ui/core';
// import { styled } from '@material-ui/styles';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';

// // Components
import Page from '../../Page';
import HeaderBreadcrumbs from '../../HeaderBreadcrumbs';
// // hooks
// import useAuth from '../../hooks/useAuth';
// import useIsMountedRef from '../../hooks/useIsMountedRef';
// eslint-disable-next-line import/no-unresolved, import/extensions
import useSettings from '../../../hooks/useSettings';
import { MIconButton } from '../../@material-extend';
// //
// import ScoreCardsContext from '../../contexts/ScoreCardsContext';
// //
// import Label from '../../components/Label';
// import Questions from './Scorecards/Questions';
// //
import { Block } from '../../../pages/components-overview/Block';
// //
// import { MIconButton } from '../../components/@material-extend';
// import NewScoreCardCFDialog from '../components-overview/material-ui/dialog/NewScoreCardCFDialog';
// import ScorecardCustomFieldsTable from '../components-overview/material-ui/table/ScorecardCustomFieldsTable';

//
import Scrollbar from '../../Scrollbar';
// import { MIconButton } from '../@material-extend';
import SettingMode from '../../settings/SettingMode';
import SettingColor from '../../settings/SettingColor';
import SettingStretch from '../../settings/SettingStretch';
import SettingDirection from '../../settings/SettingDirection';
import SettingFullscreen from '../../settings/SettingFullscreen';

// ----------------------------------------------------------------------

CompanySettings.propTypes = {
  isEdit: PropTypes.bool,
  currentUser: PropTypes.object
};

const style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  flexWrap: 'wrap',
  '& > *': { mx: '8px !important' }
};

// const AntSwitch = styled(Switch)(({ theme }) => ({
//   width: 28,
//   height: 16,
//   padding: 0,
//   display: 'flex',
//   '&:active': {
//     '& .MuiSwitch-thumb': {
//       width: 15
//     },
//     '& .MuiSwitch-switchBase.Mui-checked': {
//       transform: 'translateX(9px)'
//     }
//   },
//   '& .MuiSwitch-switchBase': {
//     padding: 2,
//     '&.Mui-checked': {
//       transform: 'translateX(12px)',
//       color: '#fff',
//       '& + .MuiSwitch-track': {
//         opacity: 1,
//         backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff'
//       }
//     }
//   },
//   '& .MuiSwitch-thumb': {
//     boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
//     width: 12,
//     height: 12,
//     borderRadius: 6,
//     transition: theme.transitions.create(['width'], {
//       duration: 200
//     })
//   },
//   '& .MuiSwitch-track': {
//     borderRadius: 16 / 2,
//     opacity: 1,
//     backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
//     boxSizing: 'border-box'
//   }
// }));

// ----------------------------------------------------------------------
const DRAWER_WIDTH = 260;

function CompanySettings() {
  const { themeStretch } = useSettings();

  // const navigate = useNavigate();
  const location = useLocation();
  // console.log('location', location.state);
  const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));
  // const { getScorecardSettings, updateScorecardSettings } = useContext(ScoreCardsContext);
  // const { updateCompanySettings, getCompanySettings, updateProfilePicture, getProfilePicture, deleteProfilePicture } =
  //   useAuth();
  // const [selectedScorecard, setSelectedScorecard] = useState(location.state);
  // const [scorecardId, setScorecardId] = useState();
  // const [selectedScorecardSettings, setSelectedScorecardSettings] = useState();

  const [images, setImages] = useState([{ data_url: '/icons/SmartCollectLogo.svg' }]);
  const [FavIcons, setFavIcons] = useState([{ data_url: '/icons/SmartCollectLogo.svg' }]);
  const maxNumber = 69;

  const refSubmitButton = useRef();

  // UI settings
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [open]);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const fetchMyAPI = async () => {
      // const response = await getCompanySettings();
      // console.log('scoreCardSettings', response);
      // setFieldValue('fileAttachments', response.fileAttachments);
      // setFieldValue('inbox', response.inbox);
      // setFieldValue('supportAccess', response.supportAccess);
      // setFieldValue('autoScore', response.autoScore);
      // setFieldValue('activityLog', response.activityLog);
      // setFieldValue('timezone', response.timezone);
      // setFieldValue('dateFormat', response.dateFormat);
      // setFieldValue('requestFlow', response.requestFlow.toString());
    };

    fetchMyAPI();
  }, []);

  // const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      id: '',
      fileAttachments: '',
      inbox: '',
      supportAccess: '',
      autoScore: '',
      activityLog: '',
      timezone: '',
      dateFormat: '',
      requestFlow: ''
    },

    onSubmit: async (values) => {
      // onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      // try {
      // await updateCompanySettings(
      //   values.fileAttachments,
      //   values.inbox,
      //   values.supportAccess,
      //   values.autoScore,
      //   values.activityLog
      // );
      // await updateCompanySettings(values);
      // enqueueSnackbar('Updated company settings', {
      //   variant: 'success',
      //   action: (key) => (
      //     <MIconButton size="small" onClick={() => closeSnackbar(key)}>
      //       <Icon icon={closeFill} />
      //     </MIconButton>
      //   )
      // });
      // getAllUsers("1");
      // resetForm();
      // handleClose();
      // } catch (error) {
      //   console.error(error);
      //   if (isMountedRef.current) {
      //     setSubmitting(false);
      //     setErrors({ afterSubmit: error.message });
      //   }
      // }
    },
    enableReinitialze: true
  });

  const { errors, touched, values, setFieldValue, handleSubmit, isSubmitting, getFieldProps } = formik;

  // const handleChange = (event) => {};

  useEffect(() => {
    refSubmitButton?.current?.click();
    // formik.setSubmitting(true);
  }, [values]);

  const timezone = [
    {
      id: 1,
      type: 'Pacific/Kwajalein'
    },
    {
      id: 2,
      type: 'Pacific/Midway'
    },
    {
      id: 3,
      type: 'Pacific/Honolulu'
    },
    {
      id: 4,
      type: 'America/Anchorage'
    },
    {
      id: 5,
      type: 'America/Los_Angeles'
    },
    {
      id: 6,
      type: 'America/Denver'
    },
    {
      id: 7,
      type: 'America/Tegucigalpa'
    },
    {
      id: 8,
      type: 'America/New_York'
    },
    {
      id: 9,
      type: 'America/Caracas'
    },
    {
      id: 10,
      type: 'America/Halifax'
    },
    {
      id: 11,
      type: 'America/St_Johns'
    },
    {
      id: 12,
      type: 'America/Argentina/Buenos_Aires'
    },
    {
      id: 13,
      type: 'America/Sao_Paulo'
    },
    {
      id: 14,
      type: 'Atlantic/South_Georgia'
    },
    {
      id: 15,
      type: 'Atlantic/Azores'
    },
    {
      id: 16,
      type: 'Europe/Dublin'
    },
    {
      id: 17,
      type: 'Europe/Belgrade'
    },
    {
      id: 18,
      type: 'Europe/Vilnius'
    },
    {
      id: 19,
      type: 'Europe/Minsk'
    },
    {
      id: 20,
      type: 'Asia/Kuwait'
    },
    {
      id: 21,
      type: 'Asia/Tehran'
    },
    {
      id: 22,
      type: 'Asia/Muscat'
    },
    {
      id: 23,
      type: 'Asia/Yekaterinburg'
    },
    {
      id: 24,
      type: 'Asia/Kolkata'
    },
    {
      id: 25,
      type: 'Asia/Katmandu'
    },
    {
      id: 26,
      type: 'Asia/Dhaka'
    },
    {
      id: 27,
      type: 'Asia/Rangoon'
    },
    {
      id: 28,
      type: 'Asia/Krasnoyarsk'
    },
    {
      id: 29,
      type: 'Asia/Brunei'
    },
    {
      id: 30,
      type: 'Australia/Darwin'
    },
    {
      id: 31,
      type: 'Australia/Brisbane'
    },
    {
      id: 32,
      type: 'Asia/Magadan'
    },
    {
      id: 33,
      type: 'Pacific/Fiji'
    },
    {
      id: 34,
      type: 'Pacific/Tongatapu'
    },
    {
      id: 35,
      type: 'UTC'
    }
  ];

  const dateType = [
    {
      id: 1,
      type: 'DD/MM/YYYY'
    },
    {
      id: 2,
      type: 'MM/DD/YYYY'
    }
  ];

  const handlelocalization = () => {
    // getFieldProps('timezone').value;
    // getFieldProps('dateFormat').value;
    // updateCompanySettings(formik.values);
  };

  const onChange = async (imageList, addUpdateIndex) => {
    // data for submit
    console.log('imageList', imageList);
    // console.log('imageListIndex', addUpdateIndex);
    setImages(imageList);
    console.log('images', images);

    console.log('imageList', imageList[0]);
    if (imageList.length > 0) {
      const base64Img = imageList[0]?.data_url;
      const file = base64ImageToBlob(base64Img);
      console.log(file);
      // updateProfilePicture(base64ImageToBlob(base64Img));
    } else {
      // deleteProfilePicture();
    }
  };

  const onFavIconChange = async (imageList, addUpdateIndex) => {
    // data for submit
    console.log('imageList', imageList);
    // console.log('imageListIndex', addUpdateIndex);
    setFavIcons(imageList);
    console.log('favIcon', FavIcons);

    console.log('imageList', imageList[0]);
    if (imageList.length > 0) {
      const base64Img = imageList[0]?.data_url;
      const file = base64ImageToBlob(base64Img);
      console.log(file);
      // updateProfilePicture(base64ImageToBlob(base64Img));
    } else {
      // deleteProfilePicture();
    }
  };
  const base64ImageToBlob = (str) => {
    // extract content type and base64 payload from original string
    const pos = str.indexOf(';base64,');
    const type = str.substring(5, pos);
    const b64 = str.substr(pos + 8);

    // decode base64
    const imageContent = atob(b64);

    // create an ArrayBuffer and a view (as unsigned 8-bit)
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    // fill the view, using the decoded base64
    for (let n = 0; n < imageContent.length; n += 1) {
      view[n] = imageContent.charCodeAt(n);
    }

    // convert ArrayBuffer to Blob
    const blob = new Blob([buffer], { type });

    return blob;
  };

  const title = (
    <span>
      <Typography display="inline" variant="h4">
        {' '}
        Company Settings{' '}
      </Typography>{' '}
    </span>
  );

  return (
    <Page title="Settings | SmartCollect">
      {!loggedUserData?.staff && (
        <HeaderBreadcrumbs
          sx={{ pl: 4, ml: 3 }}
          links={[{ name: 'Home', href: PATH_DASHBOARD.general.dashboard }, { name: 'Company Settings' }]}
        />
      )}
      {loggedUserData?.staff?.staffType === 10 && (
        <HeaderBreadcrumbs
          sx={{ pl: 4, ml: 3 }}
          links={[{ name: 'Home', href: '/employee/dashboard' }, { name: 'Company Settings' }]}
        />
      )}
      {loggedUserData?.staff?.staffType === 20 && (
        <HeaderBreadcrumbs
          sx={{ pl: 4, ml: 3 }}
          links={[{ name: 'Home', href: '/supervisor/dashboard' }, { name: 'Company Settings' }]}
        />
      )}

      {/* <Stack>

        <Alert severity="warning">
          Warning!
          This form is locked so editing has been disabled. You must Unlock the Scorecard to continue.
        </Alert>

      </Stack> */}
      <Container maxWidth={themeStretch ? false : 'xl'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <Block title={title} sx={style}>
          {/* {allCustomFields && <ScorecardCustomFieldsTable data={allCustomFields} />} */}
          {/* <Container maxWidth={themeStretch ? false : 'xl'}> */}
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        File attachments:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>Off</Typography>
                            {/* <AntSwitch
                              checked={values.fileAttachments}
                              {...getFieldProps('fileAttachments')}
                              inputProps={{ 'aria-label': 'ant design' }}
                            /> */}
                            <FormControlLabel
                              control={
                                <Switch {...getFieldProps('fileAttachments')} checked={values.fileAttachments} />
                              }
                              label=""
                              // sx={{ m: 2 }}
                            />
                            <Typography>On</Typography>
                          </Stack>
                          {/* <Typography sx={{ alignItems: 'center' }} variant="subtitle2">
                            {' '}
                            This will enable/disable the uploading of file attachments on scorecards.{' '}
                          </Typography> */}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Inbox:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>Off</Typography>
                            {/* <AntSwitch
                              checked={values.inbox}
                              {...getFieldProps('inbox')}
                              inputProps={{ 'aria-label': 'ant design' }}
                            /> */}
                            <FormControlLabel
                              control={<Switch {...getFieldProps('inbox')} checked={values.inbox} />}
                              label=""
                              // sx={{ m: 2 }}
                            />
                            <Typography>On</Typography>
                          </Stack>
                          {/* <Typography sx={{ alignItems: 'center' }} variant="subtitle2">
                            {' '}
                            This will enable/disable the inbox feature.{' '}
                          </Typography> */}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Support Access:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>Off</Typography>
                            {/* <AntSwitch
                              checked={values.supportAccess}
                              {...getFieldProps('supportAccess')}
                              inputProps={{ 'aria-label': 'ant design' }}
                            /> */}
                            <FormControlLabel
                              control={<Switch {...getFieldProps('supportAccess')} checked={values.supportAccess} />}
                              label=""
                              // sx={{ m: 2 }}
                            />
                            <Typography>On</Typography>
                          </Stack>
                          {/* <Typography sx={{ alignItems: 'center' }} variant="subtitle2">
                            {' '}
                            This setting will allow the Scorebuddy support team to login and view your system.{' '}
                          </Typography> */}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Auto Score:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>Off</Typography>
                            {/* <AntSwitch
                              checked={values.autoScore}
                              {...getFieldProps('autoScore')}
                              inputProps={{ 'aria-label': 'ant design' }}
                            /> */}
                            <FormControlLabel
                              control={<Switch {...getFieldProps('autoScore')} checked={values.autoScore} />}
                              label=""
                              // sx={{ m: 2 }}
                            />
                            <Typography>On</Typography>
                          </Stack>
                          {/* <Typography sx={{ alignItems: 'center' }} variant="subtitle2">
                            {' '}
                            This setting will enable or disable the Auto Scoring functionality.{' '}
                          </Typography> */}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Team Admin Activity Log:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>Off</Typography>
                            {/* <AntSwitch
                              checked={values.activityLog}
                              {...getFieldProps('activityLog')}
                              inputProps={{ 'aria-label': 'ant design' }}
                            /> */}
                            <FormControlLabel
                              control={<Switch {...getFieldProps('activityLog')} checked={values.activityLog} />}
                              label=""
                              // sx={{ m: 2 }}
                            />
                            <Typography>On</Typography>
                          </Stack>
                          {/* <Typography sx={{ alignItems: 'center' }} variant="subtitle2">
                            {' '}
                            This setting will enable or disable visibility of a team's activity to their Team Admin.{' '}
                          </Typography> */}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Localisation:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <FormControl style={{ minWidth: 500 }}>
                              <InputLabel id="section-type-label">Timezone</InputLabel>
                              <Select
                                labelId="section-type-label"
                                id="demo-select-small"
                                value={values.timezone}
                                label="Timezone"
                                // onChange={handleTypeChange}
                                {...getFieldProps('timezone')}
                                error={Boolean(touched.type && errors.type)}
                                helperText={touched.type && errors.type}
                              >
                                {timezone?.map((item) => (
                                  <MenuItem key={item.id} id={item.id} value={item.type}>
                                    {item.type}
                                  </MenuItem>
                                ))}
                              </Select>
                              {formik.errors.type && formik.touched.type ? (
                                <Typography sx={{ color: 'red', pl: 1, fontSize: '12px', p: 1 }}>
                                  {formik.errors.type}
                                </Typography>
                              ) : null}
                            </FormControl>
                          </Stack>

                          <Stack direction="row" spacing={1} alignItems="center">
                            <FormControl style={{ minWidth: 500 }}>
                              <InputLabel id="section-type-label">Date Format</InputLabel>
                              <Select
                                labelId="section-type-label"
                                id="demo-select-small"
                                value={values.dateFormat}
                                label="Date Format"
                                // onChange={handleTypeChange}
                                {...getFieldProps('dateFormat')}
                                error={Boolean(touched.type && errors.type)}
                                helperText={touched.type && errors.type}
                              >
                                {dateType?.map((item) => (
                                  <MenuItem key={item.id} id={item.id} value={item.type}>
                                    {item.type}
                                  </MenuItem>
                                ))}
                              </Select>
                              {formik.errors.type && formik.touched.type ? (
                                <Typography sx={{ color: 'red', pl: 1, fontSize: '12px', p: 1 }}>
                                  {formik.errors.type}
                                </Typography>
                              ) : null}
                            </FormControl>
                          </Stack>
                          <Typography> Date/Time Example: 17/08/2022,6:20am </Typography>
                          <Button sx={{ width: 200 }} onClick={() => handlelocalization()} variant="outlined">
                            Change Localization
                          </Button>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        One to One Request Flow:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                      >
                        <Stack>
                          <FormControlLabel
                            {...getFieldProps('requestFlow')}
                            value="10"
                            label="Supervisor And/Or Evaluator"
                            control={<Radio checked={values.requestFlow === '10'} size="small" />}
                          />
                          {/* <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            The Employee chooses whether 1:1 requests go directly ot the Supervisor, Evaluator, or both.
                          </Typography> */}
                          <FormControlLabel
                            {...getFieldProps('requestFlow')}
                            value="20"
                            label="Supervisor Only"
                            control={<Radio checked={values.requestFlow === '20'} size="small" />}
                          />
                          {/* <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            All 1:1 requests will go directly to the Supervisor.
                          </Typography> */}
                          <FormControlLabel
                            {...getFieldProps('requestFlow')}
                            value="30"
                            label="Evaluator Only"
                            control={<Radio checked={values.requestFlow === '30'} size="small" />}
                          />
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            All 1:1 requests will go directly to the Evaluator.
                          </Typography>
                          <FormControlLabel
                            {...getFieldProps('requestFlow')}
                            value="40"
                            label="Evaluator Via The Supervisor"
                            control={<Radio checked={values.requestFlow === '40'} size="small" />}
                          />
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            All 1:1 requests go to the Supervisor, who can reject the request or escalate it to the
                            Evaluator.
                          </Typography>
                        </Stack>
                      </RadioGroup>
                      {/* <Typography sx={{ marginTop: '30px' }} variant="subtitle1">
                        {' '}
                        This setting will control who receives the One to One notification request.{' '}
                      </Typography> */}
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Current Header Logo:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack spacing={3}>
                        {/* {images.length === 0 && (
                          <img src="/icons/SmartCollectLogo.svg" alt="smart-collect-logo" width="200px" />
                        )} */}
                        <ImageUploading
                          multiple
                          value={images}
                          onChange={onChange}
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps
                          }) => (
                            // write your building UI
                            <div className="upload__image-wrapper">
                              {/* <button
                                style={isDragging ? { color: 'red' } : undefined}
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Click or Drop here
                              </button>
                              &nbsp;
                              <button onClick={onImageRemoveAll}>Remove all images</button> */}
                              {/* {imageList.map((image, index) => {
                                console.log('image1', image);
                                return (
                                  <div key={index} className="image-item">
                                    <img
                                      src={image.data_url}
                                      alt=""
                                      width="200"
                                      height="200"
                                      style={{ borderRadius: '50%' }}
                                    />
                                    <div className="image-item__btn-wrapper">
                                      <Button onClick={() => onImageUpdate(index)} variant="outlined">
                                        Update
                                      </Button>{' '}
                                      &nbsp; or &nbsp;
                                      <Button onClick={() => onImageRemove(index)} variant="outlined">
                                        Remove
                                      </Button>
                                    </div>
                                  </div>
                                );
                              })} */}
                              {imageList.length > 0 ? (
                                imageList.map((image, index) => (
                                  <div key={index} className="image-item">
                                    <img
                                      src={image.data_url}
                                      alt=""
                                      width="200"
                                      height="200"
                                      style={{ borderRadius: '50%' }}
                                    />
                                    <div className="image-item__btn-wrapper">
                                      <Button onClick={() => onImageUpdate(index)} variant="outlined">
                                        Update
                                      </Button>{' '}
                                      &nbsp; or &nbsp;
                                      <Button onClick={() => onImageRemove(index)} variant="outlined">
                                        Remove
                                      </Button>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="image-item">
                                  <img alt="" width="500" height="100" style={{ borderRadius: '50%' }} />
                                  <div className="image-item__btn-wrapper">
                                    <Button onClick={() => onImageUpdate()} variant="outlined">
                                      Update
                                    </Button>{' '}
                                    &nbsp; or &nbsp;
                                    <Button onClick={() => onImageRemove()} variant="outlined">
                                      Remove
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </ImageUploading>{' '}
                        <Button sx={{ width: 200 }} variant="outlined">
                          Change Password
                        </Button>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Current Fav Icon:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack spacing={3}>
                        {/* {images.length === 0 && (
                          <img src="/icons/SmartCollectLogo.svg" alt="smart-collect-logo" width="200px" />
                        )} */}
                        <ImageUploading
                          multiple
                          value={FavIcons}
                          onChange={onFavIconChange}
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps
                          }) => (
                            // write your building UI
                            <div className="upload__image-wrapper">
                              {/* <button
                                style={isDragging ? { color: 'red' } : undefined}
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Click or Drop here
                              </button>
                              &nbsp;
                              <button onClick={onImageRemoveAll}>Remove all images</button> */}
                              {/* {imageList.map((image, index) => {
                                console.log('image1', image);
                                return (
                                  <div key={index} className="image-item">
                                    <img
                                      src={image.data_url}
                                      alt=""
                                      width="200"
                                      height="200"
                                      style={{ borderRadius: '50%' }}
                                    />
                                    <div className="image-item__btn-wrapper">
                                      <Button onClick={() => onImageUpdate(index)} variant="outlined">
                                        Update
                                      </Button>{' '}
                                      &nbsp; or &nbsp;
                                      <Button onClick={() => onImageRemove(index)} variant="outlined">
                                        Remove
                                      </Button>
                                    </div>
                                  </div>
                                );
                              })} */}
                              {imageList.length > 0 ? (
                                imageList.map((image, index) => (
                                  <div key={index} className="image-item">
                                    <img
                                      src={image.data_url}
                                      alt=""
                                      width="200"
                                      height="200"
                                      style={{ borderRadius: '50%' }}
                                    />
                                    <div className="image-item__btn-wrapper">
                                      <Button onClick={() => onImageUpdate(index)} variant="outlined">
                                        Update
                                      </Button>{' '}
                                      &nbsp; or &nbsp;
                                      <Button onClick={() => onImageRemove(index)} variant="outlined">
                                        Remove
                                      </Button>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="image-item">
                                  <img alt="" width="500" height="100" style={{ borderRadius: '50%' }} />
                                  <div className="image-item__btn-wrapper">
                                    <Button onClick={() => onImageUpdate()} variant="outlined">
                                      Update
                                    </Button>{' '}
                                    &nbsp; or &nbsp;
                                    <Button onClick={() => onImageRemove()} variant="outlined">
                                      Remove
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </ImageUploading>{' '}
                        <Button sx={{ width: 200 }} variant="outlined">
                          Change Password
                        </Button>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container sx={{ p: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography sx={{ alignItems: 'center' }} variant="subtitle1">
                        {' '}
                        Theme Settings:{' '}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Stack>
                        <Stack direction={{ xs: 'column' }} spacing={2}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>Off</Typography>
                            {/* <AntSwitch onClick={handleToggle} inputProps={{ 'aria-label': 'ant design' }} /> */}
                            <FormControlLabel control={<Switch checked={open} onClick={handleToggle} />} label="" />
                            <Typography>On</Typography>
                          </Stack>
                          {/* <Typography sx={{ alignItems: 'center' }} variant="subtitle2"> This will enable/disable the uploading of file attachments on scorecards. </Typography> */}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                </Grid>

                {/* <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={handleClose} /> */}

                <Box
                  sx={{
                    top: 12,
                    bottom: 12,
                    right: 0,
                    position: 'fixed',
                    zIndex: 2001,
                    ...(open && { right: 12 })
                  }}
                >
                  {/* <Box
                    sx={{
                      p: 0.5,
                      px: '4px',
                      mt: -3,
                      left: -44,
                      top: '50%',
                      color: 'grey.800',
                      position: 'absolute',
                      bgcolor: 'common.white',
                      borderRadius: '24px 0 16px 24px',
                      boxShadow: (theme) => theme.customShadows.z12
                    }}
                  >
                    <Tooltip title="Settings">
                      <MIconButton
                        color="inherit"
                        onClick={handleToggle}
                        sx={{
                          p: 0,
                          width: 40,
                          height: 40,
                          transition: (theme) => theme.transitions.create('all'),
                          '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                        }}
                      >
                        <Icon icon={open ? closeFill : options2Fill} width={20} height={20} />
                      </MIconButton>
                    </Tooltip>
                  </Box> */}

                  <Paper
                    sx={{
                      height: 1,
                      width: '0px',
                      overflow: 'hidden',
                      boxShadow: (theme) => theme.customShadows.z24,
                      transition: (theme) => theme.transitions.create('width'),
                      ...(open && { width: DRAWER_WIDTH })
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ py: 2, pr: 1, pl: 2.5 }}
                    >
                      <Typography variant="subtitle1">Settings</Typography>
                      <MIconButton onClick={handleClose}>
                        <Icon icon={closeFill} width={20} height={20} />
                      </MIconButton>
                    </Stack>
                    <Divider />

                    <Scrollbar sx={{ height: 1 }}>
                      <Stack spacing={4} sx={{ pt: 3, px: 3, pb: 15 }}>
                        <Stack spacing={1.5}>
                          <Typography variant="subtitle2">Mode</Typography>
                          <SettingMode />
                        </Stack>

                        <Stack spacing={1.5}>
                          <Typography variant="subtitle2">Direction</Typography>
                          <SettingDirection />
                        </Stack>

                        <Stack spacing={1.5}>
                          <Typography variant="subtitle2">Color</Typography>
                          <SettingColor />
                        </Stack>

                        <Stack spacing={1.5}>
                          <Typography variant="subtitle2">Stretch</Typography>
                          <SettingStretch />
                        </Stack>

                        <SettingFullscreen />
                      </Stack>
                    </Scrollbar>
                  </Paper>
                </Box>
              </Grid>
              <LoadingButton
                sx={{ visibility: 'hidden' }}
                type="submit"
                variant="contained"
                ref={refSubmitButton}
                loading={isSubmitting}
              >
                Save Scorecard
              </LoadingButton>
            </Form>
          </FormikProvider>

          {/* </Container> */}
        </Block>
      </Container>
    </Page>
  );
}
export default CompanySettings;
